"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _StepContent.default;
  }
});

var _StepContent = _interopRequireDefault(require("./StepContent"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/StepContent/index.js
// module id = 568
// module chunks = 0